import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  arePassengerWaiversComplete,
  getBookingOnce,
  getFilledPassengerWaivers,
  getInquiryDataById,
  getListingByID,
  getRequiredPassengerWaivers,
} from "../utils";

const isRenterDrivingTrip = (boatDetails, inquiryData) => {
  const offer = inquiryData?.offerData;
  if (offer?.captainCheckbox) return false;
  if (
    boatDetails?.boatType === "Fishing Guide" ||
    boatDetails?.boatType === "Fishing Charter"
  ) {
    return false;
  }
  if (boatDetails?.boatCaptain === true) return false;
  return true;
};

const getWaiversCompleteGuidanceTitle = (boatDetails, inquiryData) => {
  if (isRenterDrivingTrip(boatDetails, inquiryData)) {
    return "Passenger waivers are complete!";
  }
  return "Waivers complete!";
};

const getWaiversCompleteGuidanceMessage = (boatDetails, inquiryData) => {
  if (isRenterDrivingTrip(boatDetails, inquiryData)) {
    return 'Nothing left to do until you arrive at the pickup location and meet the boat owner. Once there, the boat driver will click on the booking on the calendar and click "Start Trip".';
  }
  return "All required waivers are complete — you're good to go! Show up at the agreed time and location on trip day. Your captain will start the trip from their end — just relax and enjoy!";
};

export default function WaiverThankYou() {
  const location = useLocation();
  const bookingId = location.state?.bookingId;
  const [cardTitle, setCardTitle] = useState("Thank You!");
  const [cardMessage, setCardMessage] = useState("");

  useEffect(() => {
    const loadBookingGuidance = async () => {
      if (!bookingId) {
        setCardMessage(
          "Your waiver was submitted successfully. Visit your dashboard to view your bookings."
        );
        return;
      }

      try {
        const bookingData = await getBookingOnce(bookingId);
        if (!bookingData) {
          return;
        }

        const [listingData, inquiryData] = await Promise.all([
          getListingByID(bookingData.listingId),
          bookingData.inquiryId
            ? getInquiryDataById(bookingData.inquiryId)
            : Promise.resolve(null),
        ]);

        const passengersComplete = arePassengerWaiversComplete(
          bookingData,
          listingData
        );
        const waiversComplete =
          passengersComplete &&
          bookingData.status === "Waiver Filled" &&
          getFilledPassengerWaivers(bookingData) >=
            getRequiredPassengerWaivers(bookingData, listingData);

        if (waiversComplete) {
          localStorage.setItem(`waiversCompleteGuidanceSeen_${bookingId}`, "1");
          setCardTitle(
            getWaiversCompleteGuidanceTitle(listingData, inquiryData)
          );
          setCardMessage(getWaiversCompleteGuidanceMessage(listingData, inquiryData));
          return;
        }

        setCardTitle("Thank You!");
        setCardMessage("Your waiver was submitted successfully.");
      } catch (error) {
        console.error("Error loading waiver thank-you guidance:", error);
        setCardMessage(
          "Your waiver was submitted successfully. Visit your dashboard to view your bookings."
        );
      }
    };

    loadBookingGuidance();
  }, [bookingId]);

  return (
    <Container className="mt-5 mb-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <Card.Title>{cardTitle}</Card.Title>
              <Card.Text>
                {cardMessage}
                {bookingId && (
                  <>
                    {" "}
                    <Link to={`/dashboard/event/${bookingId}`}>
                      Go to your booking
                    </Link>
                  </>
                )}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
